var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExplore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.47715 6.47715 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM14.47 13.35L16.47 8.42C16.5476 8.23448 16.504 8.02037 16.36 7.88L16.12 7.64C15.9796 7.496 15.7655 7.45238 15.58 7.53L10.65 9.53C10.1556 9.73309 9.76309 10.1256 9.56 10.62L7.56 15.55C7.48238 15.7355 7.526 15.9496 7.67 16.09L7.91 16.33C8.05037 16.474 8.26448 16.5176 8.45 16.44L13.38 14.44C13.8744 14.2369 14.2669 13.8444 14.47 13.35Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExplore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/explore.3742ada4.svg";
export { ForwardRef as ReactComponent };